<template>
  <div class="directory-node">
    <div
      class="directory-item"
      :class="{
        'selected': selectedDir && selectedDir.id === dir.id,
        'is-root': isRootNode,
        'readonly': dir.editable === false
      }"
      :style="{ paddingLeft: (level * 14 + 6) + 'px' }"
      v-draggable="isRootNode ? null : dir.id"
      v-droppable="handleDropIn"
      :data-dir-id="dir.id"
      @click.stop="handleSelect"
      @contextmenu.prevent="showContextMenu($event)"
    >
      <Icon
        v-if="hasChildren"
        :type="expanded ? 'md-remove' : 'md-add'"
        class="expand-icon"
        @click.stop="expanded = !expanded"
      />
      <span v-else class="expand-placeholder"></span>
      <Icon :type="getDirectoryIcon(dir)" class="dir-icon" style="margin-right:5px;" />
      <span class="directory-name">{{ dir.name }}</span>
      <BaseIcon v-if="dir.type === 'private' || dir.is_private" icon="md-lock" :size="14" class="dir-badge-icon" style="margin-left:5px;" />
      <BaseIcon v-if="dir.type === 'link-dir' || dir.type === 'remote'" icon="lianjie" :size="14" class="dir-badge-icon" style="margin-left:5px;" />
      <span v-if="dir.type === 'system'" class="system-badge">系统</span>
      <span v-if="dir.type === 'link-dir' || dir.type === 'remote'" class="link-badge">链接</span>
    </div>
    <div v-if="expanded && hasChildren" class="directory-children">
      <directory-node
        v-for="child in dir.subs"
        :key="child.id"
        :dir="child"
        :selected-dir="selectedDir"
        :level="level + 1"
        :is-root="false"
        :all-dirs-flat="allDirsFlat"
        @on-select="$emit('on-select', $event)"
        @on-drop-in="$emit('on-drop-in', $event)"
        @on-drop-file="$emit('on-drop-file', $event)"
        @on-config="$emit('on-config', $event)"
        @on-context-action="$emit('on-context-action', $event)"
      />
    </div>
  </div>
</template>

<script>
import BaseIcon from '@/components/base/Icon';

export default {
  name: 'DirectoryNode',
  components: {BaseIcon},
  props: {
    dir: {
      type: Object,
      required: true,
    },
    selectedDir: {
      type: Object,
      default: null,
    },
    level: {
      type: Number,
      default: 0,
    },
    isRoot: {
      type: Boolean,
      default: false,
    },
    allDirsFlat: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      expanded: true,
    };
  },
  computed: {
    hasChildren() {
      return this.dir.subs && this.dir.subs.length > 0;
    },
    isRootNode() {
      return this.isRoot && (this.dir.parent_id === null || this.dir.parent_id === undefined);
    },
  },
  methods: {
    getDirectoryIcon(dir) {
      if (this.isRootNode) {
        return 'md-cube'; // 根数据库图标
      }
      if (dir.type === 'system') {
        return 'md-settings';
      }
      if (dir.type === 'link-dir' || dir.type === 'remote') {
        return 'md-link';
      }
      return 'md-folder';
    },
    handleSelect() {
      this.$emit('on-select', this.dir);
    },
    showContextMenu(e) {
      const dir = this.dir;
      const isRoot = this.isRootNode;
      this.$contextmenu({
        event: e,
        items: [
          { label: '新增子目录', onClick: () => {
            this.$emit('on-select', dir);
            this.$emit('on-context-action', { action: 'add', dir });
          }},
          { label: '编辑', disabled: isRoot, onClick: () => {
            this.$emit('on-select', dir);
            this.$emit('on-context-action', { action: 'edit', dir });
          }},
          { label: '删除', disabled: isRoot, onClick: () => {
            this.$emit('on-context-action', { action: 'remove', dir });
          }},
        ],
        zIndex: 9999,
        minWidth: 120,
      });
    },
    handleDropIn(draggedId, targetData) {
      if (!targetData || !targetData.dirId) return;
      this.$emit('on-drop-in', {
        draggedId,
        targetDirId: targetData.dirId,
      });
      this.$emit('on-drop-file', {
        draggedId,
        targetDirId: targetData.dirId,
      });
    },
  },
};
</script>

<style lang="less" scoped>
.directory-node {
  .directory-item {
    padding: 2px 6px;
    margin: 0;
    min-height: 24px;
    line-height: 22px;
    border-radius: 3px;
    cursor: pointer;
    display: flex;
    align-items: center;
    transition: all 0.2s;
    user-select: none;
    position: relative;

    &:hover {
      background: var(--border);
    }

    &.selected {
      background: var(--primary);
      color: #fff;

      .link-badge {
        background: rgba(255, 255, 255, 0.3);
      }

      .dir-icon{
        color: #fff !important;
      }
    }

    .expand-icon {
      width: 14px;
      height: 14px;
      margin-right: 4px;
      cursor: pointer;
      display: flex;
      align-items: center;
      justify-content: center;
      border: 1px solid var(--border);
      border-radius: 2px;
    }

    .expand-placeholder {
      width: 14px;
      margin-right: 4px;
    }

    .directory-name {
      flex: 1;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }

    .link-badge {
      font-size: 10px;
      padding: 2px 6px;
      background: var(--subtext3);
      color: #fff;
      border-radius: 2px;
      margin-left: 5px;
    }
    
    .system-badge {
      font-size: 10px;
      padding: 2px 6px;
      background: var(--primary);
      color: #fff;
      border-radius: 2px;
      margin-left: 5px;
    }
    
    .dir-badge-icon {
      color: var(--subtext2);
      
      .selected & {
        color: rgba(255, 255, 255, 0.8);
      }
    }

    .dir-icon{
      color:var(--primary);
    }

    .selected .dir-icon{
      color: #fff !important;
    }

    &.is-root .dir-icon {
      color: var(--primary)
    }
    &.is-root.selected .dir-icon {
      color: rgba(255, 255, 255, 0.95);
    }
  }

  .directory-children {
    margin-left: 0;
    margin-top: 0;
  }
}

.ugo-draggable {
  opacity: 0.5;
}

.ugo-droppable {
  background: var(--primary-light) !important;
  border: 2px dashed var(--primary) !important;
}
</style>

